import Vue from 'vue'
import App from './App.vue'

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import router from './router'
import '@/assets/less/app.less'

import store from './store'
import './permission' // 判断是否登陆

Vue.use(ElementUI)

Vue.config.productionTip = false

import COMMON_GLOBAL from './utils/common'
Object.keys(COMMON_GLOBAL).forEach((key) => {
  Vue.prototype[key] = COMMON_GLOBAL[key]
})

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app')
